import { render, staticRenderFns } from "./IconOnCircleBackground.vue?vue&type=template&id=ee025edc&scoped=true&"
import script from "./IconOnCircleBackground.vue?vue&type=script&lang=ts&"
export * from "./IconOnCircleBackground.vue?vue&type=script&lang=ts&"
import style0 from "./IconOnCircleBackground.vue?vue&type=style&index=0&id=ee025edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee025edc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
